<template>
  <b-modal
    ref="modal"
    header-class="border-bottom-0"
    footer-class="border-top-0"
    @hide="handleHide()"
    hide-title
    hide-footer
  >
    <div class="container">
      <div class="row mb-5">
        <div class="col-md-12 text-center">
          <h1 class="text-success"><i class="fas fa-check-circle"></i></h1>
          <h3>{{ successMessage }}</h3>
          <h5 class="text-muted">{{ statusText }} número #{{ order.number }}</h5>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-6">
          <button
            role="button"
            class="btn btn-block btn-outline-secondary"
            @click="handleBack()"
          >
            <i class="fas fa-arrow-left" />
            Voltar
          </button>
        </div>
        <div class="col-6">
          <button
            role="button"
            class="btn btn-block btn-success"
            @click="handleNewOrder()"
          >
            <i class="fas fa-plus" />
            Novo
          </button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import orderStatus from "@/mixins/order/OrderStatus";

export default {
  mixins: [orderStatus],

  data: () => ({
    order: {},
    newOrder : false
  }),

  computed: {
    statusText() {
      if (this.order.id) {
        return this.statuses[this.order.operation_id][this.order.status].text;
      }
    },

    successMessage() {
      if (this.order.id) {
        return this.statuses[this.order.operation_id][this.order.status]
          .successMessage;
      }
    },
  },

  methods: {
    show(order) {
      this.reset()
      this.order = order;
      this.$refs.modal.show();
    },

    reset() {
      this.newOrder = false
    },

    handleBack() {
      this.$refs.modal.hide()
    },

    handleNewOrder() {
      this.newOrder = true
      this.$refs.modal.hide()
    },

    handleHide() {
      if (this.newOrder) {
        this.$emit('newOrder')
      } else {
        this.$emit('return')
      }
    }
    
  },
};
</script>

<style>
</style>